(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (gallery.classList.contains('is-ready')) return;
      const panels = [...gallery.querySelectorAll('[data-media-panel]')];
      if (!panels.length) return;
      if (!panels.some(p => p.classList.contains('is-active'))) panels[0].classList.add('is-active');
      gallery.classList.add('is-ready');
    });
  }
  function show(gallery, id) {
    const panels = [...gallery.querySelectorAll('[data-media-panel]')];
    const target = panels.find(p => p.dataset.mediaPanel === String(id));
    if (!target) return;
    panels.forEach(panel => {
      panel.classList.toggle('is-active', panel === target);
      if (panel !== target) {
        panel.querySelectorAll('video').forEach(v => v.pause());
        panel.querySelectorAll('iframe').forEach(f => { const source=f.getAttribute('src'); if(source) f.setAttribute('src',source); });
      }
    });
    gallery.querySelectorAll('[data-media-target]').forEach(a => {
      if (a.dataset.mediaTarget === String(id)) a.setAttribute('aria-current','true');
      else a.removeAttribute('aria-current');
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-media-target]');
    if (!link) return;
    event.preventDefault();
    show(link.closest('[data-gallery]'), link.dataset.mediaTarget);
  });
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-variant-radio]');
    if (!input || !input.dataset.mediaId) return;
    const gallery = input.closest('[data-product-section]')?.querySelector('[data-gallery]');
    if (gallery) show(gallery,input.dataset.mediaId);
  });
  document.addEventListener('shopify:section:load',event => initialize(event.target));
  initialize();
})();
/* Keep the main image and thumbnails within the desktop viewport. */
(() => {
  let frame;

  function fitGallery() {
    document.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (window.innerWidth < 990) {
        gallery.style.removeProperty('--sd-stage-height');
        return;
      }

      const thumbnails = gallery.querySelector('.sd-thumbnails');

      const galleryTop =
        gallery.getBoundingClientRect().top + window.scrollY;

      const thumbnailHeight = thumbnails
        ? thumbnails.getBoundingClientRect().height
        : 0;

      const availableHeight =
        window.innerHeight - galleryTop - thumbnailHeight - 20;

      const imageHeight = Math.max(
        120,
        Math.min(760, availableHeight)
      );

      gallery.style.setProperty(
        '--sd-stage-height',
        `${Math.floor(imageHeight)}px`
      );
    });
  }

  function scheduleFit() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitGallery);
  }

  window.addEventListener('resize', scheduleFit);
  window.addEventListener('load', scheduleFit);

  document.addEventListener(
    'shopify:section:load',
    scheduleFit
  );

  if (document.fonts) {
    document.fonts.ready.then(scheduleFit);
  }

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(scheduleFit);
    const header = document.querySelector('.site-header');

    if (header) {
      observer.observe(header);
    }

    document
      .querySelectorAll('.sd-product .breadcrumb')
      .forEach(element => observer.observe(element));
  }

  scheduleFit();
})();